module.exports = {"demande_de_sav":"Request","un_souci_avec_un_produit_il_vous_suffit_de_commencer_une_nouvelle_demande_de_sav":"Having a problem with a product? Just start a service request.","commencer":"Start","mes_produits":"My products","retrouver_tous_vos_produits":"Find all your products","consulter":"Check","mon_compte":"My account","retrouver_toutes_les_informations_de_votre_compte":"Find all your account information","voir":"See"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/default/en/home/home.lang.json
// module id = xxLi
// module chunks = 1